import React, { useEffect, useState } from "react";
import { GridRow, GridColumn } from "emotion-flex-grid";
import { useDispatch, useSelector } from "react-redux";

import Meta from "shared/Meta";
import BtnToolBar from "shared/BtnToolBar/index";
import Rating from "shared/Rating";
import Ingredients from "./Ingredients";
import Directions from "./Directions";
import MyRecipe from "./Recipe";
import IngredientsTitle from "./IngredientsTitle";
import Modal from "shared/Modal";
import { Icon } from "components/SvgIcons";
import {
  ToolBarWrap,
  RecipeRow,
  RecipeColumnIngredients,
  RecipeTitle,
  TitleDirection,
} from "components/RecipeSteps/Preview/styled";
import { HeadBlock } from "components/Collection/styled";
import {
  CollectionsTitle,
  ModalWrapper,
  RecipeColumnDirections,
  EquipmentItem,
  EquipmentTitle,
  EquipmentWrap,
  BackToCollection,
  BackText,
  RatingWrapDesktop,
  RatingText,
  ModalOver,
  Row,
  ServingsText,
  ServingsLeft,
  ServingsWrapper,
} from "./styled";

import { hideVideoModal } from "store/modalReducer";
import { saveRecipeOrCollection, unSaveRecipeOrCollection, buyRecipe } from "store/recipesReducer/recipesActions";
import { togglePamentModal, modalVideo, modalPayment, modalPaidInCollection } from "store/modalReducer";
import { savePrivateCollection, saveRecipePage } from "store/collectionReducer";
import { toggleModal, isUserLogin } from "store/loginReducer";
import { Content } from "styles/General.styled";
import { purshaseRecipe } from "api/api";
import { settingsCollections } from "shared/Slider/settings";
import { CollectionsSlider } from "shared/Slider/styled";
import { useRouter } from "next/router";
import { clearErrors } from "store/alert";
import { useStateMachine } from "little-state-machine";
import { updateAction, cleansAction, sortDirections } from "helpers";
import { getRatingsMessage } from "helpers/getRatingsMessage";
import { showVideoConversionStub } from "../../helpers/detectBrowser";
import { setRecipe } from "store/collectionReducer/collectionActions";
import BuyInAppModal from "components/BuyInAppModal";

import dynamic from "next/dynamic";
const Reviews = dynamic(() => import("components/Reviews"), { ssr: false });
const SliderTemplate = dynamic(() => import("shared/Slider"));
const Payment = dynamic(() => import("components/Payment"), { ssr: false });
const VideoModal = dynamic(() => import("./VideoModal"));
const StepModal = dynamic(() => import("./StepModal"));
import PaidInCollection from "components/PaidInCollection";
import Banner from "../../shared/Banner";
import MadeItButton from "components/MadeItButton";
import { timeConvert } from "../../helpers/getFormatedTime";
import { getOwner } from "store/userReducer/userSelectors";
import { getMainVideo } from "../../helpers/video";

const creatorBtns = [
  { name: "Edit", icon: "edit_large" },
  { name: "Share", icon: "share2", entityType: "recipe" },
  { name: "Like", icon: "saveslide" },
];

const viewerBtns = [
  { name: "Share", icon: "share2", entityType: "recipe" },
  { name: "Like", icon: "saveslide" },
];

const RecipePage = ({ recipe }) => {
  const router = useRouter();
  const [isVideo, setVideoPage] = useState(null);
  const isLogin = useSelector(isUserLogin);
  const currentUser = useSelector(getOwner);
  const isUserCreator = recipe.recipe_creator.id === currentUser.id;
  const btns = isUserCreator && !router.query.collection ? creatorBtns : viewerBtns;
  const [buyInAppModalVisible, setBuyInAppModalVisible] = useState(false);

  const dispatch = useDispatch();
  const isShowModal = useSelector(modalVideo);
  const isPaymentModal = useSelector(modalPayment);
  const isPaidInCollectionModal = useSelector(modalPaidInCollection);
  const owner = useSelector(getOwner);

  const canMakeReview = isUserCreator || recipe.purchased || !recipe.paid;
  const canMadeIt = isLogin && canMakeReview;

  const { actions } = useStateMachine({ updateAction, cleansAction });

  const _showVideoConversionStub = showVideoConversionStub(recipe);

  useEffect(() => {
    window.addEventListener("click", hideModal);
    return () => {
      window.removeEventListener("click", hideModal);
    };
  }, []);

  const hideModal = (e) => {
    if (e.target.id === "overlay") {
      dispatch(hideVideoModal());
    }
  };

  const handleClick = () => {
    if (!isLogin) return dispatch(toggleModal(true));
    const action = recipe.saved ? unSaveRecipeOrCollection : saveRecipeOrCollection;
    dispatch(
      action({
        type: "recipes",
        id: recipe.id,
        setSaved: saveRecipePage,
      })
    );
  };

  const showPayment = () => {
    setBuyInAppModalVisible(false);
    dispatch(togglePamentModal(true));
  };

  const toFirstPage = () => {
    dispatch(clearErrors());
    sessionStorage.setItem("isTheFormOfRecipesSubmit", false);

    const normalizedRecipe = sortDirections(recipe);

    actions.updateAction(normalizedRecipe);

    router.push("/edit-recipe");
  };

  const toCollectionPreview = () => {
    router.push("/add-collection/preview");
  };

  const renderLoginBanner = () => {
    if ((!isLogin && recipe.paid) || (!isLogin && recipe.paid)) {
      return <Banner description="Sign up for a FREE account to save these recipes" />;
    }
  };

  const closeBuyInApp = () => {
    setBuyInAppModalVisible(false);
  };

  return (
    <>
      {isShowModal && (
        <ModalOver>
          <Modal type="primary">
            <ModalWrapper>
              <Row>
                <Content>
                  {isVideo ? (
                    <VideoModal
                      title={recipe.title}
                      ingredients={recipe}
                      video={getMainVideo(recipe)}
                      image={recipe.main_image}
                      setVideoPage={setVideoPage}
                      paid={recipe.paid}
                      isPrivate={recipe.private}
                      purchased={recipe.purchased}
                      isCreator={isUserCreator}
                      showStepsButton={showStepsButton(recipe)}
                      showVideoConversionStub={_showVideoConversionStub}
                    />
                  ) : (
                    <StepModal
                      title={recipe.title}
                      ingredients={recipe}
                      video={getMainVideo(recipe)}
                      setVideoPage={setVideoPage}
                      paid={recipe.paid}
                      isPrivate={recipe.private}
                      purchased={recipe.purchased}
                      isCreator={isUserCreator}
                      isOwner={owner}
                      recipeCreator={recipe.recipe_creator}
                      purshased={isUserCreator || recipe.purchased}
                      price={recipe.price}
                      isLogin={isLogin}
                    />
                  )}
                </Content>
              </Row>
            </ModalWrapper>
          </Modal>
        </ModalOver>
      )}
      <HeadBlock className="height" hideBorder>
        {router.query.collection && (
          <BackToCollection onClick={toCollectionPreview}>
            <Icon icon="arrow_left" />
            <BackText>Back to Collection publishing</BackText>
          </BackToCollection>
        )}
        <GridRow display={["block", "flex"]} justify="between" wrap="wrap">
          <GridColumn width={[12, 6, 6, 8]}>
            <RecipeTitle>{recipe.title}</RecipeTitle>
            <Meta user={recipe.recipe_creator} isEdited={recipe.is_edited} />
          </GridColumn>
          <GridColumn width={[12, "auto"]} ml={["", "auto"]} className="hide-mobile-global">
            <ToolBarWrap>
              <MadeItButton madeIt={recipe.made_it} recipeId={recipe.id} canMadeIt={canMadeIt} />
              <BtnToolBar
                saved={recipe.saved}
                onSave={handleClick}
                onClick={toFirstPage}
                btns={btns}
                socialImgUrl={recipe.main_image}
                isRecipe
                recipeId={recipe.id}
              />
            </ToolBarWrap>
          </GridColumn>
        </GridRow>
        <ServingsWrapper>
          <ServingsLeft>
            <ServingsText className="first">
              {" "}
              <Icon icon="yield" /> {recipe.yields[0]?.number} {recipe.yields[0]?.type?.name}
            </ServingsText>
            <ServingsText className="second">
              {" "}
              <Icon icon="time" /> {timeConvert(recipe.total_time)}
            </ServingsText>
            <ServingsText className="third">
              {" "}
              <Icon icon="check_circle" />
              Foodys made it {recipe.made_it_sum} time{recipe.made_it_sum == 1 || recipe.made_it_sum == 0 ? "" : "s"}
            </ServingsText>
          </ServingsLeft>
          <RatingWrapDesktop hasReviews={recipe.review_count}>
            <RatingText>{getRatingsMessage(recipe.review_count)}</RatingText>
            <Rating value={recipe.rating} />
          </RatingWrapDesktop>
        </ServingsWrapper>
      </HeadBlock>
      <MyRecipe
        saved={recipe.saved}
        handleClick={handleClick}
        image={recipe.main_image}
        total_time={recipe.total_time}
        prepare_ahead={recipe.prepare_ahead}
        yields={recipe.yields[0]}
        tags={recipe.tags}
        isCreator={isUserCreator}
        description={recipe.description}
        video={getMainVideo(recipe)}
        paid={recipe.paid}
        isPrivate={recipe.private}
        setVideoPage={setVideoPage}
        purshased={recipe.purchased}
        showStepsButton={showStepsButton(recipe)}
        onEdit={toFirstPage}
        rating={recipe.rating}
        review_count={recipe.review_count}
        price={recipe.price}
        canMadeIt={canMadeIt}
        madeIt={recipe.made_it}
        id={recipe.id}
      />
      {renderLoginBanner()}

      <RecipeRow paid={recipe.paid} purshased={isUserCreator || recipe.purchased}>
        <RecipeColumnIngredients>
          {recipe?.equipment?.length > 0 && (
            <EquipmentWrap>
              <EquipmentTitle>Special Equipment</EquipmentTitle>
              {recipe.equipment.map(({ id, name }) => (
                <EquipmentItem key={id}>{name}</EquipmentItem>
              ))}
            </EquipmentWrap>
          )}

          <IngredientsTitle
            id={recipe.id}
            type="recipe"
            paid={recipe.paid}
            purchased={isUserCreator || recipe.purchased}
            isActive={isUserCreator || recipe.purchased || !recipe.paid}
            isInGrocery={recipe.in_grocery}
            isPrivate={recipe.private}
            isLogin={isLogin}
            showLogin={() => dispatch(toggleModal(true))}
            showPayment={() => {
              setBuyInAppModalVisible(true);
            }}
          />

          <Ingredients
            isOwner={owner}
            recipeCreator={recipe.recipe_creator}
            paid={recipe.paid}
            purshased={isUserCreator || recipe.purchased}
            ingredients={recipe.element_ingredient}
            isLogin={isLogin}
          />
        </RecipeColumnIngredients>

        <RecipeColumnDirections>
          <TitleDirection>Directions</TitleDirection>
          <Directions
            paid={recipe.paid}
            purshased={isUserCreator || recipe.purchased}
            directions={recipe.element_direction}
            showPayment={() => {
              setBuyInAppModalVisible(true);
            }}
            isPrivate={recipe.private}
            isLogin={isLogin}
            rec={recipe}
          />
        </RecipeColumnDirections>
      </RecipeRow>
      {!recipe.purchased && recipe.private && (
        <>
          <CollectionsTitle>You can buy this recipe in following collections: </CollectionsTitle>
          <CollectionsSlider>
            <SliderTemplate
              list={recipe.collections}
              image={`/images/image.jpg`}
              icon="save"
              type="collections"
              isCreatorData={true}
              context="collection"
              setSaved={savePrivateCollection}
              settingsSlider={settingsCollections}
              size="middle slider-type1"
            />
          </CollectionsSlider>
        </>
      )}

      <BuyInAppModal isVisible={buyInAppModalVisible} onClose={closeBuyInApp} confirm={showPayment} />

      {isPaymentModal && (
        <Payment
          modalLabel="Buy Recipe"
          price={recipe.price}
          purshase={(id) => purshaseRecipe({ recipe: id })}
          purshaseConfirm={buyRecipe}
          purshaseItem={recipe.id}
          hasStripe={recipe.has_stripe_account}
          creator={recipe.recipe_creator}
          refetchProduct={setRecipe}
        />
      )}

      {isPaidInCollectionModal && <PaidInCollection recipe={recipe} collections={recipe.collections} />}

      <Reviews type="recipe" data={recipe} canMakeReview={canMakeReview} />
    </>
  );
};

export default RecipePage;

/** Traverse element_direction and return true if at least on direction has video or image
 * @method
 * @param { Object } recipe recipe object
 * @returns { Boolean } if true show steps modal button
 */
export function showStepsButton(recipe) {
  try {
    let elDir = recipe?.element?.element_direction || recipe.element_direction;
    if (!elDir || !elDir.length) {
      return false;
    }
    let dirs = elDir.reduce((acc, val) => [...acc, ...val.direction], []);
    return dirs.find((d) => d.main_image || getMainVideo(d));
  } catch (e) {
    console.log("search image in steps error", e);
  }
}
